import React, { FC } from 'react'
import { CarouselContent_s } from './carousel-styles'
import CarouselAutomation from "components/carousel-automation"

interface Props {
  controls: object,
  defaults?: object,
  field: string,
  data: object,
  namedItems?: object,
  persist: Function
  table?: string
}

const SingleStateContent: FC<Props> = (props) => {
  const Control = props.controls['single'] ? props.controls['single'].control : props.controls['basic'].control;

  return (
    <CarouselContent_s>
      <Control field={props.field} rowData={props.data} persist={props.persist} namedItems={props.namedItems} defaults={props.defaults} />
      <CarouselAutomation />
    </CarouselContent_s>
  )

}

export default SingleStateContent
